import getOngoingOnboarding from 'api/v2/transactions/getOngoingOnboarding';
import { useQuery } from 'react-query';
import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';

const useGetBankingOnboardingStatus = () =>
  useQuery([BankTransactionsCacheKeys.OngoingOnboarding], getOngoingOnboarding);

export default useGetBankingOnboardingStatus;
